// Copyright (c) 2016 Deere & Company
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const UserSettingsNavigationItem = ({ label, path }) => (
    <li className="user-settings-navigation-item">
        <NavLink
            activeClassName="selected"
            to={path}
        >
            <FormattedMessage id={label} />
        </NavLink>
    </li>
);

UserSettingsNavigationItem.displayName = 'UserSettingsNavigationItem';
UserSettingsNavigationItem.propTypes = {
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
};

export default UserSettingsNavigationItem;
